import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Stack, Alert, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import { createGroup } from '../../controllers/groupManagementController';

const CreateGroupDialog = ({ open, onClose, onCreated }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setName('');
    setDescription('');
    setError('');
    setLoading(false);
  };

  const handleClose = () => {
    reset();
    onClose?.();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const created = await createGroup({ name, description });
      toast.success('Grup başarıyla oluşturuldu');
      onCreated?.(created);
      handleClose();
    } catch (err) {
      setError(err?.message || 'Grup oluşturulamadı');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          fontSize: '18px',
          fontWeight: 500,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pr: 3,
        }}
      >
        Yeni Grup
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent sx={{ py: 2, px: 3 }}>
          <Stack spacing={2}>
            {error && <Alert severity="error">{error}</Alert>}
            <Box>
              <Typography variant="body2" sx={{ mb: 0.6, fontWeight: 500 }}>
                Grup Adı
              </Typography>
              <TextField
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder=""
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '5px',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0E4D94',
                    },
                  },
                  '& .MuiInputBase-input': {
                    py: 1.2,
                    px: 1.5,
                    fontSize: '14px',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#e6e6e6',
                  },
                }}
              />
            </Box>
            <Box>
              <Typography variant="body2" sx={{ mb: 0.6, fontWeight: 500 }}>
                Açıklama
              </Typography>
              <TextField
                fullWidth
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
                placeholder=""
                multiline
                minRows={4}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '5px',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0E4D94',
                    },
                  },
                  '& .MuiInputBase-input': {
                    fontSize: '14px',
                    px: 0,
                    py: 0,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#e6e6e6',
                  },
                }}
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ py: 2, px: 3 }}>
          <Button
            onClick={handleClose}
            disabled={loading}
            sx={{
              textTransform: 'none',
              fontSize: '13px',
              color: '#666666',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            İptal
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              textTransform: 'none',
              fontSize: '13px',
              backgroundColor: '#0E4D94',
              borderRadius: '5px',
              px: 2,
              '&:hover': {
                backgroundColor: '#0a3d7a',
              },
              '&:disabled': {
                backgroundColor: '#e6e6e6',
                color: '#a3a3a3',
              },
            }}
          >
            Oluştur
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateGroupDialog;


